import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import InfinityLoader from '../dropdownSearch/infinityLoader';

import { getSelectedPortal, selectPortal } from '../../redux/portal/actions';
import utils from '../../utils';
import API from '../../services/api';

const PortalSelector = ({ outline = false, customTitle, customLabel, onSelection, customSelected }) => {
  const [portals, setPortals] = useState([]);
  const [portalObjects, setPortalObjects] = useState([]);
  const [totalSize, setTotalSize] = useState(0);
  const [selectedPortal, setSelectedPortal] = useState(null);
  const [currentFilter, setCurrentFilter] = useState('');
  const initialPortal = useSelector(getSelectedPortal);

  const dispatch = useDispatch();

  useEffect(() => {
    onLoadPortals();
  }, [API.access_token]);

  const handleSelection = portal => {
    setSelectedPortal(portal);
    onSelection ? onSelection(portal) : dispatch(selectPortal(portalObjects.find(p => p.id === portal.value)));
  };

  const handleInitialSelection = () => {
    if (!customSelected && initialPortal && portals.length > 0) {
      return { value: initialPortal.id, label: initialPortal.displayName };
    } else if (customSelected) {
      return customSelected;
    } else {
      return selectedPortal ? { label: selectedPortal.label, value: selectedPortal.value } : null;
    }
  };

  const onLoadPortals = (nextPageToken, searchingBy = '') => {
    const query = encodeURI(`displayName ILIKE "%${searchingBy}%" OR id ILIKE "%${searchingBy}%"`);
    const filter = searchingBy !== '' ? query : '';

    if (filter !== currentFilter) {
      setPortals([]);
    }

    if (API.access_token) {
      return API.getPortals(40, nextPageToken, filter).then(response => {
        setTotalSize(response.totalSize);
        const portalOptions = response.brandPortals.map(portal => ({
          value: portal.id,
          label: portal.displayName
        }));
        const refreshedSelectedPortal = response.brandPortals.find(portal => portal.id === initialPortal?.id);

        if (refreshedSelectedPortal) {
          dispatch(selectPortal(refreshedSelectedPortal));
        }

        if (filter !== currentFilter) {
          setCurrentFilter(filter);
          setPortals(portalOptions);
          setPortalObjects(response.brandPortals);
        } else {
          const newPortals = utils.mergeArraysByField(portalOptions, portals, 'value');
          const newPortalsObjects = utils.mergeArraysByField(response.brandPortals, portalObjects, 'id');
          setPortalObjects(newPortalsObjects);
          setPortals(newPortals);
        }
        return response.nextPageToken;
      });
    }
  };

  return (
    <InfinityLoader
      title={customTitle || ''}
      label={customLabel || ''}
      leftAlign
      outline={outline}
      selected={handleInitialSelection()}
      onSelect={portalId =>
        handleSelection({
          value: portalId,
          label: portals.find(portal => portal.value === portalId)?.label || ''
        })
      }
      totalSize={totalSize}
      onLoading={onLoadPortals}
      options={portals}
    />
  );
};

export default PortalSelector;
